import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getBrandById } from "../../api/brands";

const BrandDetail = () => {
  const { id } = useParams();
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    const fetchBrand = async () => {
      const _brand = await getBrandById(id);

      setBrand(_brand);
    }

    fetchBrand();
  }, [id]);

  if (!id || !brand) return null;

  return (
    <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
      <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">{brand?.name}</h1>
    </div>
  )
}

export default BrandDetail;
